import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { calendarIcon } from '@justgiving/icons';

import IconLabel from '../IconLabel/IconLabel';
import { useEvent } from './useEvent';

const EventDetails: FunctionComponent = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { joinUrl, event } = useEvent();

  if (!event) return null;

  const title = event?.title;
  if (!title) return null;

  const startDateString = event
    ? new Date(event.startDate).getTime().toString()
    : '';
  const endDateString = event
    ? new Date(event.endDate).getTime().toString()
    : '';

  const getLabel = () => {
    const eventDetails =
      startDateString === endDateString
        ? t('page.eventDetailsSingleDay', {
            title,
            startDateString,
          })
        : t('page.eventDetailsMultiDay', {
            title,
            startDateString,
            endDateString,
          });

    const startFundraisingLink = joinUrl ? (
      <a href={joinUrl}>{t('page.eventStartFundraising')}</a>
    ) : (
      ''
    );

    return (
      <span>
        {t('page.eventLabel')} {eventDetails} {startFundraisingLink}
      </span>
    );
  };

  return (
    <div data-qa="event-details">
      <IconLabel icon={calendarIcon} label={getLabel()} />
    </div>
  );
};

export default EventDetails;
